import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { removeFieldError } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import NewCardCvvField from 'apps/auth/components/form/NewCardCvvField';
import Form from 'apps/auth/components/form-multi/Form';
import { transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import { CVV_ADDED, CVV_DIALOG_SHOWN, CVV_ENTERED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYMENT_FLOW, PAYMENT_METHOD_AMPLITUDE, PAYOUT_COUNTRY, PAYOUT_METHOD } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { PAYMENT_METHOD, SOURCE_CARD_CVV } from 'apps/auth/constants/fieldsName';
import { AUTH_SEND_PAY } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const PostPrechequeCvvPopup = ({ popupRef = null, ...props }) => {
    const submitRef = useRef(null);
    const { deliveryMethod, toCountry, sendFlowV3 } = useExtra();
    const { fields = {} } = useForm(props.formName);

    const amplitudeDeliveryMethod = transactionMethods[deliveryMethod];
    const amplitudeSendingMethod = transactionMethods[props.sendingMethod];

    useEffect(() => {
        if (sendFlowV3) {
            amplitude.getInstance().logEvent(CVV_DIALOG_SHOWN);
        }
    }, []);

    useEffect(() => {
        if (props.cvvIsError) {
            props.removeFieldError(props.formName, SOURCE_CARD_CVV);
        }
    }, [props.cvvValue]);

    useEffect(() => {
        if (props.cvvValue && props.cvvValue.length === 3 && !props.cvvIsError) {
            submitRef.current.click();
            amplitude.getInstance().logEvent(CVV_ADDED, {
                [PAYOUT_COUNTRY]: toCountry?.nameEn,
                [PAYOUT_METHOD]: amplitudeDeliveryMethod,
                [PAYMENT_METHOD_AMPLITUDE]: amplitudeSendingMethod,
                [PAYMENT_FLOW]: props.getPaymentFlow?.(),
            });
            if (sendFlowV3) {
                amplitude.getInstance().logEvent(CVV_ENTERED);
            }
            popupRef?.current?.close();
        }
    }, [props.cvvValue, props.cvvIsError]);

    return (
        <ComplexPopup withoutButton textCenter popupRef={popupRef}>
            <Form id="precheque_cvv" action={AUTH_SEND_PAY} formName={props.formName} fields={fields} getCanonicalPath={true}>
                <ComplexPopupRow>{MarkdownService.removeNewlines(props.title)}</ComplexPopupRow>
                {props.cvv && <NewCardCvvField field={props.cvv} formName={props.formName} focus={true} isNewInput isCenteredInput />}
                <Button type="submit" variant="hidden" ref={submitRef} />
            </Form>
        </ComplexPopup>
    );
};
const mapStateToProps = (state, ownProps) => {
    return {
        cvv: state.form[ownProps.formName].fields[SOURCE_CARD_CVV],
        cvvValue: state.form[ownProps.formName].fields[SOURCE_CARD_CVV]?.value,
        cvvIsError: state.form[ownProps.formName].fields[SOURCE_CARD_CVV]?.isError,
        sendingMethod: state.form[ownProps.formName].fields[PAYMENT_METHOD]?.value,
    };
};
export default connect(mapStateToProps, { removeFieldError })(PostPrechequeCvvPopup);
